import { render, staticRenderFns } from "./CisternaPrimariaList.vue?vue&type=template&id=3dec3963&scoped=true&"
import script from "./CisternaPrimariaList.vue?vue&type=script&lang=js&"
export * from "./CisternaPrimariaList.vue?vue&type=script&lang=js&"
import style1 from "./CisternaPrimariaList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec3963",
  null
  
)

export default component.exports